export const stateValidator = {
    methods: {
        $_redirectIfFail() {
            //debugger
            // validate route params
            let notFound = false

            if (this.$route.name === 'editor') {
                if (!this.editor) {
                    this.$router.push({name: 'editors'})
                    //location.pathname = '/editors'
                } else if (this.reel) {
                    this.$router.push({
                        name: 'editor-reel',
                        params: {editor: this.editor.slug, reel: this.reel.slug}
                    })
                }
            } else if (this.$route.name === 'editor-reel') {
                if (!this.editor) {
                    this.$router.push({name: 'editors'})
                } else if (!this.reel) {
                    this.$router.push({
                        name: 'editor',
                        params: {editor: this.editor.slug}
                    })
                }
            } else if (this.$route.name === 'editor-detail') {
                if (!this.editor) {
                    this.$router.push({name: 'editors'})
                } else if (!this.reel) {
                    this.$router.push({
                        name: 'editor',
                        params: {editor: this.editor.slug}
                    })
                } else if (!this.media) {
                    this.$router.push({
                        name: 'editor-reel',
                        params: {editor: this.editor.slug, reel: this.reel.slug}
                    })
                }
            }

            if (notFound) {
                this.$router.push({name: 'home'})
            }
        }
    }
}
